var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 15.1667V20.5C5.33331 24.8997 5.33331 27.0996 6.70015 28.4665C8.06698 29.8333 10.2669 29.8333 14.6666 29.8333H17.3333C21.733 29.8333 23.9329 29.8333 25.2998 28.4665C26.6666 27.0996 26.6666 24.8997 26.6666 20.5V15.1667",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.5C4 11.5031 4 11.0046 4.26795 10.6333C4.44348 10.3901 4.69596 10.1881 5 10.0477C5.46411 9.83334 6.08717 9.83334 7.33333 9.83334H24.6667C25.9128 9.83334 26.5359 9.83334 27 10.0477C27.304 10.1881 27.5565 10.3901 27.732 10.6333C28 11.0046 28 11.5031 28 12.5C28 13.4969 28 13.9953 27.732 14.3667C27.5565 14.6099 27.304 14.8119 27 14.9523C26.5359 15.1667 25.9128 15.1667 24.6667 15.1667H7.33333C6.08717 15.1667 5.46411 15.1667 5 14.9523C4.69596 14.8119 4.44348 14.6099 4.26795 14.3667C4 13.9953 4 13.4969 4 12.5Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5476C8 4.23264 9.06599 3.16666 10.3809 3.16666H10.8571C13.6975 3.16666 16 5.46919 16 8.30951V9.83332H12.2857C9.91877 9.83332 8 7.91454 8 5.5476Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.5476C24 4.23264 22.934 3.16666 21.6191 3.16666H21.1428C18.3025 3.16666 16 5.46919 16 8.30951V9.83332H19.7143C22.0812 9.83332 24 7.91454 24 5.5476Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.1667V29.8333",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftingIcon);
export default __webpack_public_path__ + "static/media/gifting-icon.2d821a56eb7933660060d3bd388a479c.svg";
export { ForwardRef as ReactComponent };